module.exports = __webpack_public_path__ + "static/media/logo-report-footer.62c611b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/branding/applied-reserve-analysis/logo-report-footer.png
// module id = 513
// module chunks = 0